import React, { useEffect, useState } from 'react';
import { customersProductsApi } from '@/api/api';
import { Store } from '@/models/customersTypes';
import { inputClass } from '@/components/Forms/FormField';

export const storeLabel = (name: string) => name.replace(/^Yobsti\s*-\s*[A-Z]\d+\s*/, '').trim() || name;

let storesRequest: Promise<Store[]> | null = null;

const loadStores = () => {
    storesRequest ??= customersProductsApi
        .getInitData()
        .then((data) => [...data.stores].sort((a, b) => storeLabel(a.name).localeCompare(storeLabel(b.name), 'de')))
        .catch((error) => {
            storesRequest = null;
            throw error;
        });
    return storesRequest;
};

export function useStores() {
    const [stores, setStores] = useState<Store[]>([]);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let active = true;
        loadStores()
            .then((sorted) => active && setStores(sorted))
            .catch(() => active && setFailed(true));
        return () => {
            active = false;
        };
    }, []);

    return { stores, failed };
}

interface StoreSelectProps {
    id: string;
    value: string;
    stores: Store[];
    failed: boolean;
    onChange: (store: string) => void;
}

const StoreSelect: React.FC<StoreSelectProps> = ({ id, value, stores, failed, onChange }) => {
    return (
        <select id={id} value={value} onChange={(e) => onChange(e.target.value)} disabled={failed} className={inputClass}>
            <option value="" disabled>
                {failed
                    ? 'Standorte konnten nicht geladen werden'
                    : stores.length ? 'Standort auswählen' : 'Standorte werden geladen …'}
            </option>
            {stores.map((store) => (
                <option key={store.id} value={store.name}>
                    {storeLabel(store.name)}{store.city && !store.name.includes(store.city) ? ` (${store.city})` : ''}
                </option>
            ))}
        </select>
    );
};

export default StoreSelect;
